export const TID = {
  // Landing
  loginGoogleBtn: "login-google-btn",
  heroCta: "hero-cta",
  downloadChromeBtn: "download-chrome-btn",
  downloadFirefoxBtn: "download-firefox-btn",
  // Dashboard
  dashboardRoot: "dashboard-root",
  newPostBtn: "new-post-btn",
  logoutBtn: "logout-btn",
  filterStatus: "filter-status",
  filterPlatform: "filter-platform",
  postRow: "post-row",
  postDelete: "post-delete",
  postRetry: "post-retry",
  postAnalytics: "post-analytics",
  extensionTokenBtn: "extension-token-btn",
  extensionTokenValue: "extension-token-value",
  copyTokenBtn: "copy-token-btn",
  // Composer
  composerUrl: "composer-url",
  composerCaption: "composer-caption",
  composerPlatformFb: "composer-platform-facebook",
  composerPlatformIg: "composer-platform-instagram",
  composerPlatformLi: "composer-platform-linkedin",
  composerScheduleToggle: "composer-schedule-toggle",
  composerScheduleAt: "composer-schedule-at",
  composerPostNow: "composer-post-now",
  composerSchedule: "composer-schedule",
  composerClose: "composer-close",
  // Accounts
  accountToggleFb: "account-toggle-facebook",
  accountToggleIg: "account-toggle-instagram",
  accountToggleLi: "account-toggle-linkedin",
  accountDisconnectFb: "account-disconnect-facebook",
  accountDisconnectLi: "account-disconnect-linkedin",
  accountFbPageSelect: "account-fb-page-select",
  // Analytics
  analyticsPanel: "analytics-panel",
  analyticsCloseBtn: "analytics-close-btn",
  // Auth callback
  authCallbackRoot: "auth-callback-root",
};
